import { render, staticRenderFns } from "./SettingAuto.vue?vue&type=template&id=40918808&"
import script from "./SettingAuto.vue?vue&type=script&lang=js&"
export * from "./SettingAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports